// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"85405a39","357":"419e98d7","675":"65387951","762":"18c8ca9c","982":"4b82cc57"}[chunkId] + ".chunk.css";
};